import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';
import { type ThreatVectorData } from './dto';

interface ThreatVectorProps {
    id: string;
    description?: string;
    threatPathId: string;
    assetRelationId?: string | null;
    sourceAssetId?: string;
    targetAssetId?: string;
    attackerTypeId?: string;
    weakness: string;
    tacticId: string;
    techniqueId: string;
    protectionGoalId: string;
    exploitabilityId: string;
    comment: string;
}

export class ThreatVector extends Entity {
    threatPathId: string;
    description?: string;
    assetRelationId?: string | null;
    sourceAssetId?: string;
    targetAssetId?: string;
    attackerTypeId?: string;
    weakness: string;
    tacticId: string;
    techniqueId: string;
    protectionGoalId: string;
    exploitabilityId: string;
    comment: string;

    constructor({
        id,
        description,
        threatPathId,
        assetRelationId,
        sourceAssetId,
        targetAssetId,
        attackerTypeId,
        exploitabilityId,
        weakness,
        tacticId,
        techniqueId,
        protectionGoalId,
        comment,
    }: ThreatVectorProps) {
        super({ id });
        this.description = description;
        this.threatPathId = threatPathId;
        this.assetRelationId = assetRelationId;
        this.sourceAssetId = sourceAssetId;
        this.targetAssetId = targetAssetId;
        this.attackerTypeId = attackerTypeId;
        this.exploitabilityId = exploitabilityId;
        this.weakness = weakness;
        this.tacticId = tacticId;
        this.techniqueId = techniqueId;
        this.protectionGoalId = protectionGoalId;
        this.comment = comment;
    }

    static new({
        description,
        threatPathId,
        assetRelationId,
        sourceAssetId,
        targetAssetId,
        attackerTypeId,
        exploitabilityId,
        weakness,
        tacticId,
        techniqueId,
        protectionGoalId,
        comment,
    }: Omit<ThreatVectorData, 'id'>): ThreatVector {
        const uuid = new UUID();

        return new ThreatVector({
            id: uuid.toString(),
            description,
            threatPathId,
            assetRelationId,
            sourceAssetId,
            targetAssetId,
            attackerTypeId,
            exploitabilityId,
            weakness,
            tacticId,
            techniqueId,
            protectionGoalId,
            comment,
        });
    }
}
